import { getHistory } from '../services/history';

export function isValidURL(string) {
  let url;

  try {
    url = new URL(string);
  } catch (error) {
    return false;
  }

  return url.protocol === 'http:' || url.protocol === 'https:';
}

export const getQueryBackURL = () => {
  const { location } = getHistory();
  const params = new URLSearchParams(location.search);
  const backURL = params.get('backURL');

  return backURL || null;
};

export function getValidQueryBackURL() {
  const backURL = getQueryBackURL();
  return isValidURL(backURL) ? backURL : null;
}
